import { Injectable } from "@angular/core";
import { AuthenticationModel, ChatConverter, ChatEndPoints, CheckUtils, ConversationsApiData, ConversationsMessagesModel, ConversationsModel, ConversationStateVoData, ConversationUserStatisticsVoData, logger, UsersConverter, UsersProvider, UsersResolverModel } from "../..";
import { EncryptStorageEvent, FilesModel, OrganizationModel, UserResolverVoData } from "../../index";
import { Events } from "ionic-angular";
import { FilesConverter } from "../../utils/converter/files-converter";
var ConversationsStatisticsProvider = /** @class */ (function () {
    function ConversationsStatisticsProvider(_chatEndPoints, _conversationsModel, _messagesModel, _usersProvider, _filesModel, _model, _authModel, _organizationModel, _events) {
        this._chatEndPoints = _chatEndPoints;
        this._conversationsModel = _conversationsModel;
        this._messagesModel = _messagesModel;
        this._usersProvider = _usersProvider;
        this._filesModel = _filesModel;
        this._model = _model;
        this._authModel = _authModel;
        this._organizationModel = _organizationModel;
        this._events = _events;
        this.bind();
    }
    Object.defineProperty(ConversationsStatisticsProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsStatisticsProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        });
        this._events.subscribe(this._organizationModel.event.URI_CHANGED, function () {
            _this._model.clear(false, true);
        });
    };
    ConversationsStatisticsProvider.prototype.change = function (conversation, message) {
        var _this = this;
        if (CheckUtils.isEmpty(conversation))
            return;
        if (conversation.lastPosted < message.createdDate || conversation.lastMessageId === message.uid) {
            conversation.lastPosted = message.createdDate;
            conversation.lastMessageId = message.uid;
        }
        var findExisting = false;
        for (var _i = 0, _a = conversation.usersStatictics; _i < _a.length; _i++) {
            var usersStatictic = _a[_i];
            if (usersStatictic.jid == message.authorJabberId && usersStatictic.lastPosted < message.createdDate) {
                usersStatictic.lastPosted = message.createdDate;
                findExisting = true;
                break;
            }
        }
        if (!findExisting) {
            this._usersProvider.resolveJids(new Set([message.authorJabberId]), function (res) {
                var userResolverVoData = (CheckUtils.isEmpty(res)) ? null : res.get(message.authorJabberId);
                if (CheckUtils.isEmpty(userResolverVoData)) {
                    var userVoData = _this._usersProvider.isBot(message.authorJabberId) ?
                        _this._usersProvider.addNewBot() : _this._usersProvider.addAnonymous();
                    _this._usersProvider.model.add(userVoData, false);
                    userResolverVoData = new UserResolverVoData(userVoData.uid, message.authorJabberId);
                    _this._model.add(userResolverVoData);
                }
                var conversationUserStatistics = new ConversationUserStatisticsVoData(userResolverVoData.userId, userResolverVoData.uid);
                conversationUserStatistics.lastPosted = message.createdDate;
                conversation.usersStatictics.push(conversationUserStatistics);
                _this._conversationsModel.add(conversation);
            });
        }
        else {
            this._conversationsModel.add(conversation);
        }
    };
    ConversationsStatisticsProvider.prototype.load = function (conversations, callback) {
        var _this = this;
        if (CheckUtils.isEmpty(conversations))
            this.onLoad(null, conversations, callback);
        var conversationsId = [];
        for (var _i = 0, conversations_1 = conversations; _i < conversations_1.length; _i++) {
            var conversation = conversations_1[_i];
            if (!CheckUtils.isEmpty(conversation.id) && conversation.state == ConversationStateVoData.SENDED)
                conversationsId.push(conversation.id);
        }
        this._chatEndPoints.conversationsStatistics(new ConversationsApiData(Array.from(conversationsId), this._authModel.authenticationToken, this._organizationModel.cpId))
            .then(function (res) {
            if (callback != null)
                _this.onLoad(res, conversations, callback);
        }).catch(function (err) {
            if (callback != null)
                _this.onLoad(null, conversations, callback);
            logger.info(err);
        });
    };
    ConversationsStatisticsProvider.prototype.onLoad = function (result, conversations, callback) {
        var conversationsWithStatistics = [];
        if (!CheckUtils.isEmpty(result)) {
            var conversationsStatistics = new Map();
            for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
                var conversationStatistics = result_1[_i];
                conversationsStatistics.set(conversationStatistics.roomId, conversationStatistics);
            }
            var _loop_1 = function (conversation) {
                if (conversationsStatistics.has(conversation.id)) {
                    var conversationStatistics = conversationsStatistics.get(conversation.id);
                    //Last message statistics
                    if (!CheckUtils.isEmpty(conversationStatistics.lastMessage)) {
                        var messageVoData_1 = ChatConverter.convertToMessageVoData(conversationStatistics.lastMessage);
                        var fileVoData = FilesConverter.convertToFilesVoData(conversationStatistics.lastMessage.attachments);
                        fileVoData.forEach(function (file) { return messageVoData_1.files.push(file.uid); });
                        this_1._filesModel.addAll(fileVoData);
                        this_1._messagesModel.add(messageVoData_1);
                        if (conversation.messagesId.indexOf(conversationStatistics.lastMessage.jabberId) == -1)
                            conversation.messagesId.push(conversationStatistics.lastMessage.jabberId);
                        conversation.lastMessageId = conversationStatistics.lastMessage.jabberId;
                    }
                    //Users statistics
                    if (!CheckUtils.isEmpty(conversationStatistics.userStatistics)) {
                        for (var _i = 0, _a = conversationStatistics.userStatistics; _i < _a.length; _i++) {
                            var conversationUsersStatistics = _a[_i];
                            if (!this_1._model.has(conversationUsersStatistics.user.jabberId) &&
                                CheckUtils.isEmpty(conversationUsersStatistics.user.userId)) {
                                var userVoData = this_1._usersProvider.isBot(conversationUsersStatistics.user.jabberId) ?
                                    this_1._usersProvider.addNewBot() : this_1._usersProvider.addAnonymous();
                                conversationUsersStatistics.user.userId = userVoData.id;
                                this_1._usersProvider.model.add(userVoData, false);
                                this_1._model.add(UsersConverter.convertToUserResolverVoData(conversationUsersStatistics.user));
                            }
                            else if (!CheckUtils.isEmpty(conversationUsersStatistics.user.userId)) {
                                this_1._model.add(UsersConverter.convertToUserResolverVoData(conversationUsersStatistics.user));
                            }
                            var conversationUserStatistics = new ConversationUserStatisticsVoData(conversationUsersStatistics.user.id, conversationUsersStatistics.user.jabberId);
                            conversationUserStatistics.lastPosted = conversationUsersStatistics.lastPosted;
                            conversation.usersStatictics.push(conversationUserStatistics);
                        }
                    }
                    conversationsWithStatistics.push(conversation);
                }
            };
            var this_1 = this;
            for (var _a = 0, conversations_2 = conversations; _a < conversations_2.length; _a++) {
                var conversation = conversations_2[_a];
                _loop_1(conversation);
            }
        }
        callback(conversationsWithStatistics);
    };
    ConversationsStatisticsProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ConversationsStatisticsProvider.ctorParameters = function () { return [
        { type: ChatEndPoints, },
        { type: ConversationsModel, },
        { type: ConversationsMessagesModel, },
        { type: UsersProvider, },
        { type: FilesModel, },
        { type: UsersResolverModel, },
        { type: AuthenticationModel, },
        { type: OrganizationModel, },
        { type: Events, },
    ]; };
    return ConversationsStatisticsProvider;
}());
export { ConversationsStatisticsProvider };
//# sourceMappingURL=conversations-statistics-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/chat/conversations-statistics-provider.js
// module id = 152
// module chunks = 14